"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMetaProperties = exports.getStaticMetaProperties = exports.getDynamicMetaProperties = exports.refreshHamplitudeProperties = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _helpers = require("./common/helpers");

var _storageKeys = require("./storageKeys");

var SESSION_LENGTH_IN_MILLISECONDS = 1000 * 60 * 30; // 30 minutes

var OPERATING_SYSTEMS = [{
  name: 'windows 10',
  pattern: /(Windows 10.0|Windows NT 10.0)/
}, {
  name: 'windows 8',
  pattern: /(Windows 8|Windows8.1|Windows NT 6.2|Windows NT 6.3)/
}, {
  name: 'windows 7',
  pattern: /(Windows 7|Windows NT 6.1)/
}, {
  name: 'windows vista',
  pattern: /Windows NT 6.0/
}, {
  name: 'windows xp',
  pattern: /(Windows NT 5.1|Windows XP)/
}, {
  name: 'android',
  pattern: /Android/
}, {
  name: 'linux',
  pattern: /(Linux|X11)/
}, {
  name: 'ios',
  pattern: /(iPhone|iPad|iPod)/
}, {
  name: 'mac',
  pattern: /Mac OS X|MacPPC|MacIntel|Mac_PowerPC|Macintosh/
}];
var _hamplitudeProperties = null;

var getDefaultHamplitudeProperties = function getDefaultHamplitudeProperties(currentTime, deviceIdOverride) {
  return {
    device_id: deviceIdOverride || (0, _helpers.makeUuid)(),
    last_event_id: 0,
    last_sequence_number: 0,
    last_timestamp_checked_against_session: currentTime,
    session_id: currentTime
  };
};

var getHamplitudeProperties = function getHamplitudeProperties(getTempStorage, currentTime, deviceIdOverride) {
  var hamplitudeProperties = _hamplitudeProperties;

  if (!hamplitudeProperties) {
    hamplitudeProperties = getTempStorage(_storageKeys.hamplitudeKey);

    if (!hamplitudeProperties) {
      hamplitudeProperties = getDefaultHamplitudeProperties(currentTime, deviceIdOverride);
    } else {
      hamplitudeProperties = JSON.parse(hamplitudeProperties);
    }
  }

  return hamplitudeProperties;
};

var setHamplitudeProperties = function setHamplitudeProperties(setTempStorage, hamplitudeProperties) {
  _hamplitudeProperties = hamplitudeProperties;
  setTempStorage(_storageKeys.hamplitudeKey, JSON.stringify(hamplitudeProperties));
};

var refreshHamplitudeProperties = function refreshHamplitudeProperties(hamplitudeProperties, currentTime, deviceIdOverride) {
  var last_event_id = hamplitudeProperties.last_event_id,
      last_sequence_number = hamplitudeProperties.last_sequence_number,
      session_id = hamplitudeProperties.session_id,
      last_timestamp_checked_against_session = hamplitudeProperties.last_timestamp_checked_against_session,
      rest = (0, _objectWithoutProperties2.default)(hamplitudeProperties, ["last_event_id", "last_sequence_number", "session_id", "last_timestamp_checked_against_session"]);
  var refreshed = Object.assign({}, rest);
  var timeSinceSessionRefresh = currentTime - last_timestamp_checked_against_session;

  if (timeSinceSessionRefresh > SESSION_LENGTH_IN_MILLISECONDS) {
    refreshed.last_event_id = 0;
    refreshed.session_id = currentTime;
  } else {
    refreshed.session_id = session_id;
    refreshed.last_timestamp_checked_against_session = currentTime;
  }

  refreshed.last_event_id = last_event_id + 1;
  refreshed.last_sequence_number = last_sequence_number + 1;

  if (deviceIdOverride && typeof deviceIdOverride === 'string' && deviceIdOverride !== hamplitudeProperties.device_id) {
    refreshed.device_id = deviceIdOverride;
  }

  return refreshed;
};

exports.refreshHamplitudeProperties = refreshHamplitudeProperties;

var getAndRefreshHamplitudeProperties = function getAndRefreshHamplitudeProperties(getTempStorage, setTempStorage, currentTime, deviceIdOverride) {
  var hamplitudeProperties = refreshHamplitudeProperties(getHamplitudeProperties(getTempStorage, currentTime, deviceIdOverride), currentTime, deviceIdOverride);
  setHamplitudeProperties(setTempStorage, hamplitudeProperties);
  return hamplitudeProperties;
};

var lookupOperatingSystem = function lookupOperatingSystem(fingerprint) {
  var match = 'unknown';

  try {
    OPERATING_SYSTEMS.forEach(function (_ref) {
      var name = _ref.name,
          pattern = _ref.pattern;

      if (pattern.test(fingerprint)) {
        match = name;
      }
    });
  } catch (err) {
    /* DO NOTHING */
  }

  return match.toLowerCase();
};

var getDynamicMetaProperties = function getDynamicMetaProperties(_ref2, deviceIdOverride) {
  var getTempStorage = _ref2.getTempStorage,
      setTempStorage = _ref2.setTempStorage;
  var currentTime = Date.now();
  var hamplitudeProperties = getAndRefreshHamplitudeProperties(getTempStorage, setTempStorage, currentTime, deviceIdOverride);
  var dynamicProperties = Object.assign({}, hamplitudeProperties, {
    timestamp: currentTime,
    currentPageUrl: '',
    currentPageUrlCleaned: ''
  });

  if (window && window.location) {
    var currentPageUrl = window.location.href;
    dynamicProperties.currentPageUrl = (0, _helpers.truncate)(currentPageUrl, 256);
    dynamicProperties.currentPageUrlCleaned = (0, _helpers.cleanUrl)(currentPageUrl);
  }

  if (deviceIdOverride && typeof deviceIdOverride === 'string') {
    dynamicProperties.hasDeviceIdOverride = true;
  }

  return dynamicProperties;
}; // Args visible for tests


exports.getDynamicMetaProperties = getDynamicMetaProperties;

var getStaticMetaProperties = function getStaticMetaProperties() {
  var screenGlobal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var clientName = arguments.length > 1 ? arguments[1] : undefined;
  var staticProperties = {
    windowWidth: -1,
    windowHeight: -1,
    screenWidth: -1,
    screenHeight: -1,
    screenSize: -1,
    lastPageUrl: '',
    lastPageUrlCleaned: '',
    howOsDetailed: '',
    singlePageAppSessionId: Date.now(),
    trackingClient: clientName || 'custom'
  };

  if (window) {
    staticProperties.windowWidth = window.innerWidth;
    staticProperties.windowHeight = window.innerHeight;
  }

  if (navigator) {
    if (typeof navigator.appVersion === 'string') {
      staticProperties.howOsDetailed = lookupOperatingSystem((0, _helpers.between)(navigator.appVersion, '(', ')'));
    }
  }

  if (screenGlobal && screenGlobal.width && screenGlobal.height) {
    staticProperties.screenWidth = screenGlobal.width;
    staticProperties.screenHeight = screenGlobal.height;

    if (screenGlobal.width > 1024) {
      staticProperties.screenSize = 'large (> 1024)';
    } else if (screenGlobal.width > 680) {
      staticProperties.screenSize = 'medium (680 - 1024)';
    } else {
      staticProperties.screenSize = 'small (< 680)';
    }
  }

  if (document) {
    var lastPageUrl = document.referrer;
    staticProperties.lastPageUrl = (0, _helpers.truncate)(lastPageUrl, 256);
    staticProperties.lastPageUrlCleaned = (0, _helpers.cleanUrl)(lastPageUrl);
  }

  return staticProperties;
};
/*
 *  metaProperties = properties that get stamped to each event
 *   staticProperties = properties that get set once on page load
 *   dynamicProperties = properties that can change for each event
 */


exports.getStaticMetaProperties = getStaticMetaProperties;
var getStaticMetaPropertiesOnce = (0, _helpers.once)(getStaticMetaProperties);

var getMetaProperties = function getMetaProperties(_ref3) {
  var clientName = _ref3.clientName,
      getTempStorage = _ref3.getTempStorage,
      setTempStorage = _ref3.setTempStorage;

  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref4$deviceIdOverrid = _ref4.deviceIdOverride,
      deviceIdOverride = _ref4$deviceIdOverrid === void 0 ? '' : _ref4$deviceIdOverrid;

  return Object.assign({}, getStaticMetaPropertiesOnce(screen, clientName), {}, getDynamicMetaProperties({
    getTempStorage: getTempStorage,
    setTempStorage: setTempStorage
  }, deviceIdOverride));
};

exports.getMetaProperties = getMetaProperties;